import Print from "./src/main.js";
export default Print;
